export const VEYRO = {
  name: "Veyro™ Vacuum Compression Travel Backpack",
  shortName: "Veyro™ Backpack",
  tagline: "Pack More. Carry Less.",
  description:
    "A premium travel backpack engineered around vacuum compression. Pack clothing into the built-in compression compartment, pull the air out, and watch bulky items shrink — so one sleek carry-on holds what used to take two bags.",
  price: 229.99,
  compareAt: 279.99,
  pixelId: "veyro-backpack",
  images: {
    black: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/j1chb9go_IMG_3608.jpeg",
    navy: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/lcafuw60_IMG_3607.jpeg",
    overview: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/zr3s8jd8_D4851A01-8E25-48BA-B721-C5F4B09D727E.png",
    interior: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/smj144lt_IMG_3610.jpeg",
    interiorDark: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/37eyuyn3_9AB9AADA-9697-4547-8F6D-A7544057C25E.png",
    howto: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/feu69sxv_681753C6-5E51-4696-95D0-BB80E752190E.png",
    zipper: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/rhhxzarj_F83E0D06-CA10-42D5-AE11-F7F66E499ED1.png",
    capacity: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/lips54es_520A4832-BA0C-4E4F-AF20-375A4F46C612.png",
    lock: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/b87go8os_748D6D60-4D1B-40FE-91BA-9A5F4DA0C3DA.png",
  },
};

export const COLORS = [
  { name: "Black", image: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/4rqcmcme_4DBF7DFA-88A3-414A-9AB9-37C5204443AD.png", match: ["black"] },
  { name: "Blue", image: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/htkr5m4g_AF79226F-0DC6-42DA-9637-1C9A7807919C.png", match: ["blue", "navy"] },
  { name: "Gray", image: "https://customer-assets-eiarnc6j.emergentagent.net/job_fly-free-shop/artifacts/r1zl85hq_4DF397C0-223A-4D58-8BED-DB8160DA243E.png", match: ["gray", "grey"] },
];

export const BENEFITS = [
  { icon: "Shrink", title: "Vacuum Compression Packing", text: "Load the built-in compression compartment, remove the air, and bulky clothing shrinks by up to half its packed size." },
  { icon: "Move", title: "Expandable Capacity", text: "A structured shell that expands when you need more room and cinches back to a slim, carry-on friendly profile." },
  { icon: "Lock", title: "Anti-Theft TSA Lock", text: "Integrated TSA-accepted combination lock keeps zippers secured through airports, trains, and hotels." },
  { icon: "Plane", title: "Built for Travel", text: "Weekend trips, flights, and business travel in one bag — organized storage, padded straps, and a clean, structured silhouette." },
];

// Values sourced from the product imagery. Edit freely.
export const SPECS = [
  { label: "Daily Capacity", value: "28L" },
  { label: "Expanded Capacity", value: "36L" },
  { label: "With Vacuum Compression", value: "Fits up to 60L of packed clothing" },
  { label: "Expansion", value: "+4 in (7\" → 11\" depth)" },
  { label: "Dimensions", value: "18.9\" × 13.7\" × 7\"" },
  { label: "Security", value: "Anti-theft TSA combination lock" },
  { label: "Space Saved", value: "Compression saves 50–60% space" },
];

export const COMPARISON = [
  { feature: "Vacuum compression packing", veyro: true, traditional: false },
  { feature: "Expandable capacity", veyro: true, traditional: false },
  { feature: "Fits under carry-on limits", veyro: true, traditional: false },
  { feature: "Hands-free backpack carry", veyro: true, traditional: false },
  { feature: "Built-in TSA lock", veyro: true, traditional: false },
  { feature: "Organized compartments", veyro: true, traditional: false },
  { feature: "One bag for the whole trip", veyro: true, traditional: false },
];

export const INCLUDED = [
  "1× Veyro™ Vacuum Compression Travel Backpack",
  "1× Veyro™ Mini Vacuum Compression Pump",
];

export const SHIPPING_INFO = "Ships in 1–3 business days · Standard delivery 3–7 business days";
export const RETURNS_INFO = "30-day return policy — unused items in original packaging";

export const FAQS = [
  { q: "How does it work?", a: "Pack clothing and soft items into the built-in vacuum compression compartment, seal it, and remove the excess air. Your items flatten dramatically, freeing up space in the rest of the backpack." },
  { q: "Is it lightweight?", a: "Veyro is designed as a structured yet comfortable carry — padded ergonomic straps and a balanced frame make it easy to wear even when fully packed." },
  { q: "How much can it hold?", a: "28L of daily space, 36L expanded — and with vacuum compression, it fits what would normally fill up to 60L of packed clothing (about a 24\" trolley case)." },
  { q: "What comes in the box?", a: "Your Veyro™ Vacuum Compression Travel Backpack with the built-in compression system, plus the Veyro™ Mini Vacuum Compression Pump — included with every order." },
  { q: "Is it easy to store?", a: "Yes — cinch the compression straps and the bag returns to a slim 7-inch profile that slides under seats, into overhead bins, and onto closet shelves." },
  { q: "How long does shipping take?", a: "Orders are processed within 1–3 business days. Standard shipping takes 3–7 business days; expedited options are available at checkout." },
  { q: "What is the return policy?", a: "We offer a 30-day return policy. Items must be unused and in original packaging. See our Returns & Refunds page for full details." },
];

export const CONTACT = {
  email: "catroworldteam@gmail.com",
};
